import { Accordion } from "@chakra-ui/react";
import React from "react";
import { Chart } from "react-chartjs-2"
import PluginLoader from 'chart.js/auto';
import FunnelDashboardAccordion from "../DashboardAccordion";
import { mountFunnelChartData } from './helpers/chartHelpers';

PluginLoader.register()

const FunnelDashboardChart = ({ funnelData, activeWorksData, title, columns, renderOnEnd, accordion, tipo = "histograma-consumo" }) => {

  const { column: column, lines, dates } = mountFunnelChartData({funis: funnelData, obrasAtivas: activeWorksData, tipo});

  const data = {
    labels: dates,
    datasets: [
      {
        type: "line",
        label: columns[0],
        data: lines,
        backgroundColor: "#034EA2",
        borderColor: "#034EA2",
        fill: false,
        yAxisID: tipo == "negociacoes-futuras" ? 'y1' : "y"
      },
      {
        type: "bar",
        label: columns[1],
        data: column.map(col => col.toFixed(0)),
        backgroundColor: "#ED7E30",
        barThickness: 60,
        borderRadius: 8,
        yAxisID: "y"
      },
    ],
  };

  const options = {
    legend: "bottom",
    animation: false,
    elements: {
      point: {
        backgroundColor: "red",
      },
    },
    layout: {
      padding: {
        top: 30,
      },
      border: false,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#01054C",
          font: {
            size: 14,
            weight: "bold",
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#01054C",
          font: {
            size: 14,
            weight: "bold",
          },
          callback: function(value) {
            if (value >= 1e9) return (value / 1e9).toFixed(1) + 'B';
            if (value >= 1e6) return (value / 1e6).toFixed(1) + 'M';
            if (value >= 1e3) return (value / 1e3).toFixed(1) + 'K';
            return value;
          },
        },
      },
      y1: {
        display: tipo == "negociacoes-futuras",
        type: 'linear',
        position: 'right',
        // title: {
        //     display: true,
        //     text: 'Quantidade'
        // },
        grid: {
            drawOnChartArea: false
        },
        beginAtZero: true,
        // ticks: {
        //   stepSize: 1,
        //   callback: function(value) {
        //       return Number.isInteger(value) ? value : '';
        //   }
        // }
      }
    },
    plugins: {
      datalabels: {
        color: (context) => {
          return context.dataset.type === "bar" ? "#FFF" : "#034EA2";
        },
        formatter: (value, context) => {
          let formattedValue = value;

          if (value >= 1e9) formattedValue = (value / 1e9).toFixed(0) + 'B';
          if (value >= 1e6) formattedValue = (value / 1e6).toFixed(0) + 'M';
          if (value >= 1e3) formattedValue = (value / 1e3).toFixed(0) + 'K';

          if (context.dataset.type === "line") return `${formattedValue}\n\n`;
          else return `${formattedValue}`;
        },
        font: {
          size: 15,
          weight: "bold",
        },
      },
      legend: {
        position: "bottom",
        align: "start",
        reverse: true,
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          color: "#01054C",
          font: {
            size: 12,
            weight: "bold",
          },
        },
      },
    },
  };

  return accordion ? (
    <FunnelDashboardAccordion header={title} className={`chart ${renderOnEnd ? "order-9" : ""}`}>
      <Chart options={options} data={data} className="max-h-[350px]" />
    </FunnelDashboardAccordion>
  ) : (
    <div className={`card ${renderOnEnd ? "order-9" : ""}`}>
      <h2 className="centered-title">{title}</h2>
      <Chart options={options} data={data} className="max-h-[350px]" />
    </div>
  );
};

export default FunnelDashboardChart;
